import { render, staticRenderFns } from "./FamilyData.vue?vue&type=template&id=d10fa118"
import script from "./FamilyData.vue?vue&type=script&lang=js"
export * from "./FamilyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports